$(document).ready(function () {
  // SideBar Settings
  let sections = {};
  $('section').each((_, e) => {
    sections[e.id] = e.offsetTop;
  });

  // Sidebar Menu Active Depend on Which Section
  $(window).scroll(function () {
    for (let key in sections) {
      if ($(window).scrollTop() >= sections[key]) {
        $('.js-nav__menu-list').removeClass('active');
        $(`.js-nav__menu-list[href="#${key}"]`).addClass('active');
      }
    }
  });
});
